import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerFadeEdge
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const MESSAGE_SCROLLER_FADE_STOPS: Record<MessageScrollerFadeEdge, [number, number]> = {
    start: [
        1,
        0
    ],
    end: [
        0,
        1
    ]
};

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "none",
        position: "absolute",
        start: 0,
        end: 0
    },
    bottom: {
        bottom: 0
    },
    top: {
        top: 0
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    borders,
    spaces,
    edge
}: {
    borders: NCoreUIKit.ActivePalette["borders"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    edge: MessageScrollerFadeEdge;
    isFocusVisible: boolean;
}) => {
    const styles = {
        container: {
            zIndex: shapeConfigs.layers.raised,
            height: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    if(isFocusVisible) {
        styles.container.start = borders.focus;
        styles.container.end = borders.focus;
        styles.container[edge === "start" ? "top" : "bottom"] = borders.focus;
    }

    return styles;
};
export default stylesheet;
